'use client';
import Button from '@ui/Button';
import SafeImage from '@ui/SafeImage';
import ktm from '@i/dirtyBikes/KTM.svg';
import beta from '@i/dirtyBikes/beta.png';
import gasgas from '@i/dirtyBikes/gasgas.png';
import honda from '@i/dirtyBikes/honda.svg';
import husqvarna from '@i/dirtyBikes/husqvarna.svg';
import kawasaki from '@i/dirtyBikes/kawasaki.svg';
import kingcobra from '@i/dirtyBikes/kingcobra.webp';
import sherco from '@i/dirtyBikes/sherco.png';
import suzuki from '@i/dirtyBikes/suzuki.svg';
import yamaha from '@i/dirtyBikes/yamaha.svg';
import redclock from '@i/sell-my-dirt-bike/Clock.svg';
import redEnvelop from '@i/sell-my-dirt-bike/EnvelopeSimple.svg';
import redinstaLogo from '@i/sell-my-dirt-bike/InstagramLogo.svg';
import redtrendUp from '@i/sell-my-dirt-bike/TrendUp.svg';
import redbikelogo from '@i/sell-my-dirt-bike/motocross 1.svg';

import { FAQItem } from '@c/FAQSection';
import Accordion from '@ui/Accordion';
import Head from 'next/head';
import { StaticImageData } from 'next/image';
import {
  CarouselContent,
  CarouselItem,
  CarouselNew,
  CarouselNext,
  CarouselPrevious,
} from '@ui/CarouselNew';

const HelpCategoryCard = ({
  title,
  description,
  onClick,
  buttonText,
  href,
  cardData,
}: {
  title: string;
  description: string;
  onClick?: () => void;
  href?: string;
  buttonText: string;
  cardData: { icon: File; text: string }[];
}) => (
  <div className="flex  w-[30.4rem] flex-grow flex-col justify-center gap-[4rem]  rounded-[1.2rem]  bg-gray-100 px-[2.4rem] py-[2.4rem] sm:px-[4rem] sm:py-[4rem] md:w-[38.4rem]">
    <div className="left-[4rem] top-[4rem] flex  flex-none grow-0 flex-col  items-start justify-center gap-[0.8rem] self-stretch p-0">
      <h3 className="  flex-none grow-0 items-center self-stretch text-center text-5xl font-semibold not-italic tracking-tighter">
        {title}
      </h3>
      <p className="mt-[0.8rem] h-[2.4rem]  flex-none grow-0 self-stretch text-center text-2xl font-semibold not-italic">
        {description}
      </p>
    </div>
    <div className="mt-[2.5rem] flex  flex-grow flex-col items-start gap-[1.6rem] p-0 ">
      {cardData.map((cardItem) => {
        return (
          <div key={cardItem.text} className="flex ">
            <div className="mr-[1rem] w-[2.4rem]">
              <SafeImage
                src={cardItem.icon}
                alt="header image"
                className="mb-[1rem]"
              />
            </div>
            <p className="text-[1.6rem]">{cardItem.text}</p>
          </div>
        );
      })}
    </div>

    <div className="mt-[0rem] flex flex-row items-center gap-[1rem] rounded-[0.6rem] text-center ">
      <Button
        type="secondary"
        width={'fluid'}
        onClick={onClick}
        text={buttonText}
        href={href}
      />
    </div>
  </div>
);

const BrandCard = ({
  src,
  className,
}: {
  src: string | StaticImageData;
  className?: string;
}) => (
  <div className="sm:h[20rem] flex h-[14rem] w-[17rem] items-center justify-center opacity-70 grayscale transition-all hover:cursor-pointer  hover:opacity-90 hover:shadow-lg hover:grayscale-0 sm:w-[24rem]">
    <SafeImage src={src} alt="header image" className={className} />
  </div>
);

const SellMyDirtBike = () => {
  return (
    <>
      <Head>
        <title>Sell My Dirt Bike | MX Locker</title>
      </Head>
      <div className="flex w-full flex-col items-center ">
        <div className="flex w-full flex-col px-[1.6rem] py-[4rem] sm:px-[12rem] sm:py-[10rem] ">
          <div className="texts-center">
            <h3 className="text-center  text-[3.2rem] font-semibold text-brand-extreme-lightest-black  xl:text-[4rem]">
              The Best Way to Buy and Sell Dirt Bikes.
            </h3>
            <div className="mt-[1.6rem] flex-1 text-center text-[1.6rem] font-normal text-brand-extreme-lightest-black ">
              A central marketplace curated for the dirt bike community. Built
              For Riders, By Riders.
            </div>
          </div>
          <div className="mt-[4rem] flex  h-full w-full flex-none grow-0 flex-col items-center p-0 xl:mt-[6.4rem]">
            <div className="left-[48.6rem] mb-[2.4rem] h-[2.9rem] w-[22.8rem] flex-none grow-0 text-center text-[2.2rem] font-semibold not-italic xl:mb-[3.2rem]">
              Choose your package
            </div>
            <div className="no-scrollbar flex h-full w-full gap-[2.4rem] overflow-x-scroll p-0  2xl:w-[120rem]">
              <div className="flex w-full flex-grow">
                <HelpCategoryCard
                  title="Free"
                  description="1st Gear"
                  cardData={[
                    { icon: redbikelogo, text: 'Listing your bike for free' },
                  ]}
                  buttonText="Get Started"
                  href="/create-listing"
                />
              </div>
              <div className="flex w-full flex-grow">
                <HelpCategoryCard
                  title="$19.99"
                  description="2nd Gear"
                  cardData={[
                    { icon: redclock, text: 'Featured for 24 hrs' },
                    {
                      icon: redtrendUp,
                      text: '1x bump to the top of search list',
                    },
                  ]}
                  buttonText="Get Started"
                  href="/create-listing"
                />
              </div>
              <div className="flex w-full flex-grow">
                <HelpCategoryCard
                  title="$39.99"
                  description="3rd Gear"
                  cardData={[
                    { icon: redclock, text: 'Featured for 72 hrs' },
                    {
                      icon: redtrendUp,
                      text: '2x bump to the top of search list',
                    },
                    {
                      icon: redinstaLogo,
                      text: '1x Insta Story on MX Locker account (@mxlocker)',
                    },
                    {
                      icon: redEnvelop,
                      text: 'Included in our weekly ‘Bikes for Sale’ email',
                    },
                  ]}
                  buttonText="Get Started"
                  href="/create-listing"
                />
              </div>
            </div>
          </div>
          <div className="mt-[4rem] flex w-full flex-col  items-center justify-center xl:mt-[6.4rem] xl:flex-row ">
            <div className="flex   w-full flex-col items-center justify-center gap-[2.4rem] px-[2.4rem] py-[2.4rem]  sm:px-[2rem] sm:py-[2.4rem] md:w-1/4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
              >
                <rect width="56" height="56" rx="28" fill="#EDEDED" />
                <path
                  d="M26 36C31.5228 36 36 31.5228 36 26C36 20.4772 31.5228 16 26 16C20.4772 16 16 20.4772 16 26C16 31.5228 20.4772 36 26 36Z"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M33.0713 33.0703L40 39.9991"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div className="text-center text-[1.6rem] font-normal xl:mb-[2.5rem] xl:text-[1.8rem]">
                Explore thousands of listings
              </div>
            </div>
            <div className="flex   w-full flex-col items-center justify-center gap-[2.4rem] px-[2.4rem] py-[2.4rem]  sm:px-[2rem] sm:py-[2.4rem] md:w-1/4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
              >
                <rect width="56" height="56" rx="28" fill="#EDEDED" />
                <path
                  d="M24 35V17"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M32 21V39"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M24 35L16 37V19L24 17L32 21L40 19V37L32 39L24 35Z"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div className="text-center text-[1.6rem] font-normal xl:mb-[2.5rem] xl:text-[1.8rem]">
                Use list or map view to find dirt bikes for sale in your area
              </div>
            </div>
            <div className="flex   w-full flex-col items-center justify-center gap-[2.4rem] px-[2.4rem] py-[2.4rem]  sm:px-[2rem] sm:py-[2.4rem] md:w-1/4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
              >
                <rect width="56" height="56" rx="28" fill="#EDEDED" />
                <path
                  d="M15.958 33.9705C15.8293 34.0074 15.6931 34.0091 15.5636 33.9756C15.434 33.9421 15.3158 33.8745 15.2211 33.7799C15.1265 33.6852 15.0589 33.567 15.0254 33.4374C14.9919 33.3079 14.9936 33.1717 15.0305 33.043L16.0967 29.3093C15.0608 27.4088 14.7445 25.1987 15.2058 23.0839C15.6671 20.9692 16.875 19.0915 18.6082 17.7951C20.3415 16.4986 22.4839 15.8702 24.6428 16.025C26.8017 16.1798 28.8325 17.1075 30.363 18.638C31.8935 20.1685 32.8212 22.1993 32.976 24.3582C33.1308 26.5171 32.5024 28.6595 31.2059 30.3928C29.9095 32.126 28.0318 33.3339 25.9171 33.7952C23.8023 34.2565 21.5922 33.9402 19.6917 32.9043L15.958 33.9705Z"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M23.5078 33.9862C23.9411 35.2161 24.6362 36.3373 25.5453 37.2722C26.4543 38.2071 27.5556 38.9335 28.7728 39.4011C29.9901 39.8687 31.2944 40.0664 32.5956 39.9805C33.8968 39.8946 35.1638 39.5272 36.3091 38.9037L40.0428 39.9699C40.1715 40.0068 40.3076 40.0085 40.4372 39.975C40.5668 39.9415 40.685 39.8739 40.7796 39.7792C40.8743 39.6846 40.9418 39.5664 40.9754 39.4368C41.0089 39.3073 41.0072 39.1711 40.9703 39.0424L39.9041 35.3087C40.6315 33.9745 41.0093 32.4778 41.0022 30.9582C40.9951 29.4386 40.6033 27.9455 39.8634 26.6182C39.1235 25.2908 38.0595 24.1725 36.7707 23.3673C35.4819 22.5622 34.0102 22.0965 32.4928 22.0137"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div className="text-center text-[1.6rem] font-normal xl:mb-[2.5rem] xl:text-[1.8rem]">
                Chat and negotiate with buyers & sellers
              </div>
            </div>
            <div className="flex   w-full flex-col items-center justify-center gap-[2.4rem] px-[2.4rem] py-[2.4rem]  sm:px-[2rem] sm:py-[2.4rem] md:w-1/4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
              >
                <rect width="56" height="56" rx="28" fill="#EDEDED" />
                <path
                  d="M28 27V39"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M28 17V23"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M37 37V39"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M37 17V33"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M40 33H34"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M19 33V39"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M19 17V29"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 29H22"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M31 23H25"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div className="text-center text-[1.6rem] font-normal xl:mb-[2.5rem] xl:text-[1.8rem]">
                Filter by year, make, and model to find your next bike
              </div>
            </div>
          </div>
        </div>

        <div className="flex w-full flex-col items-center justify-center px-[1.6rem] py-[4rem] xl:px-[12rem] xl:py-[10rem]">
          <div className=" text-center ">
            <h1 className="text-[2.4rem] font-semibold text-brand-extreme-lightest-black">
              Shop Dirt Bikes for Sale by Manufacturer
            </h1>
          </div>
          <div className="flex w-full max-w-[120rem] flex-wrap justify-center">
            <BrandCard src={yamaha} />
            <BrandCard src={suzuki} />
            <BrandCard src={kawasaki} />
            <BrandCard src={honda} />
            <BrandCard src={beta} />
            <BrandCard src={gasgas} />
            <BrandCard src={husqvarna} />
            <BrandCard src={sherco} />
            <BrandCard src={ktm} />
            <BrandCard src={kingcobra} />
          </div>
        </div>

        <div className="my-[10rem] flex w-full items-center justify-center">
          <div className="w-full max-w-[120rem] text-center">
            <div className="text-center text-[2rem] font-semibold sm:text-[2.4rem]">
              Why sell your dirt bike on MX Locker?
            </div>

            <div className="mt-[3.2rem] w-full space-y-32">
              <CarouselNew showStepper>
                <CarouselContent>
                  {cardData.map((card, index) => {
                    return (
                      <CarouselItem key={index}>
                        <Cards key={index} text={card.text} name={card.name} />
                      </CarouselItem>
                    );
                  })}
                </CarouselContent>
                <CarouselPrevious />
                <CarouselNext />
              </CarouselNew>
            </div>
          </div>
        </div>

        <div className="flex w-full max-w-[120rem] flex-col items-center px-[1.6rem] py-[4rem] text-center  leading-[2.4rem] md:px-[5rem] md:py-[10rem] lg:flex-row lg:px-[0rem] ">
          <div className="mb-[4rem] flex w-full flex-row justify-center text-left md:mb-[6.4rem] md:w-1/2 md:items-center">
            <div className="flex w-full flex-row justify-center text-center text-[2.4rem] font-semibold leading-[4.2rem] lg:flex-col lg:text-left lg:text-[3.2rem]">
              <span className="mr-[0.5rem]">Frequently</span>
              <p>Asked Questions</p>
            </div>
          </div>

          <div className="flex-start mt-[1.6rem] flex w-full flex-row items-center justify-center text-left lg:mt-[0] lg:w-1/2 xl:ml-[2.4rem] xl:w-1/2">
            <FAQSection />
          </div>
        </div>
      </div>
    </>
  );
};

const FAQs: FAQItem[] = [
  {
    q: 'Am I charged a selling fee when my bike is sold?',
    a: 'No. Bike listings on MX Locker vary in price, from $0 to $49.99. The price you pay for a listing will include the basic package, plus any additional enhancements you might choose. You may enhance your listing by having it featured to gain more exposure. The listings on MX Locker are the only cost for listing a dirt bike for sale, and there is zero seller fee when your bike sells.',
  },
  {
    q: 'Is the dirt bikes for sale section local?',
    a: 'Yes! The dirt bikes for sale section was built to promote local sales! Users can use the list view or map view to find dirt bikes for sale in their area.',
  },
  {
    q: 'Do I have to ship my bike?',
    a: 'Most dirt bike sales that happen on MX Locker are local. If you and the buyer decide that it is best for the bike to be shipped, that is entirely up to you.',
  },
  {
    q: 'How do I get paid?',
    a: 'All dirt bike sales on MX Locker are handled outside the site between you and the buyer. It is up to your discretion on how you want payment to be received.',
  },
];

const FAQSection = () => {
  return (
    <div className="flex w-full flex-col  gap-[1.6rem] text-[1.6rem]">
      {FAQs.map((faq) => (
        <Accordion
          divider={true}
          highlightHeaderOnOpen={true}
          hover="text"
          intent="faq"
          key={faq.q}
          title={faq.q}
        >
          <p className="pl-[1.6rem]">{faq.a}</p>
        </Accordion>
      ))}
    </div>
  );
};

const Cards = ({ text, name }: { text: string; name: string }) => {
  return (
    <div className="flex flex-col items-center gap-y-4">
      <div className="max-w-[40rem] text-[1.8rem] sm:max-w-[60rem]">{text}</div>
      <div className="mt-[1.2rem] text-[1.6rem] font-semibold">{name}</div>
    </div>
  );
};

const cardData = [
  {
    text: 'Listing my bike on MX Locker was so easy. I ended up selling my Yamaha in less than 12 hours. Finally the best service for selling a dirt bike within the motocross community.',
    name: 'Seth Martin',
  },
  {
    text: 'The new dirt bikes for sale section on MX Locker is amazing! I sold my race bike in just under 48 hours through the location finder and it was a simple and easy process! MX Locker is the Zillow of Dirt Bikes.',
    name: 'Justin Starling',
  },
  {
    text: 'MX Locker is the go to place when we have our race bikes for sale at the end of the season. Their site and app puts our bikes in front of the right audience, and they usually sell within a couple days of posting!',
    name: 'AJE Motorsports',
  },
];

export default SellMyDirtBike;
